import React from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@sopranodesign/pulse-hooks';
import { Flex } from '@sopranodesign/pulse-components';
import { AppWidget } from '@sopranodesign/pulse-bot';

const Conversation = ({ subscriber }) => {
  const {
    data,
    isSuccess
  } = useQuery({
    queryKey: [
      `subscribers/${subscriber.id}/messages`
    ]
  });

  if (!isSuccess) {
    return null;
  }

  return (
    <Flex fat="true" middle>
      <AppWidget
        name={`Conversation #${subscriber.id}`}
        messages={
          data.data.map(
            ({ message, direction, type }) => (
              {
                ...message,
                composer: { type: 'hidden' },
                content: message,
                direction: direction === 'incoming' ? 'toServer' : 'toClient',
                type
              }
            )
          )
        }
      />
    </Flex>
  );
};

Conversation.propTypes = {
  subscriber: PropTypes.object
};

export default Conversation;
